import { Box, Tabs, Tab } from '@mui/material';
import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

import { ContainedSideDrawer } from 'app/shared-components/drawers';
import { getPatientInfo } from 'app/services/patient';

import PatientFileHeader from 'app/pages/Patients/pages/PatientsPage/components/PatientDrawer/PatientFileHeader';
import PatientTab from './PrescriberPatientInfo';
import MedicinesTab from './PrescriberMedicinesTab';
import OrderHistoryTab from './PrescriberOrderHistoryTab';

const tabs = [{ title: 'patient' }, { title: 'order history' }, { title: 'medicines' }];

function PatientDrawer(props) {
  const { patient: propsPatient, closePatientDrawer } = props;

  const { data: patient, isFetched } = useQuery({
    queryKey: ['patient', propsPatient?._id],
    queryFn: () => getPatientInfo({ patientId: propsPatient?._id }),
    enabled: Boolean(propsPatient?._id),
    meta: { errorMessage: 'Failed to get patient details' },
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 5,
  });

  const isOpened = Boolean(propsPatient);
  const initialSelectedTab = 'patient';
  const [selectedTabTitle, setSelectedTabTitle] = useState(initialSelectedTab);

  function handleDrawerClose() {
    closePatientDrawer();
    setSelectedTabTitle(initialSelectedTab);
  }

  const changeSelectedTab = (e, newValue) => {
    e.stopPropagation();
    setSelectedTabTitle(newValue);
  };

  return (
    <ContainedSideDrawer open={isOpened} handleDrawerClose={handleDrawerClose}>
      <header className="flex items-center justify-between px-20 py-12 border-b-2 border-b-grey-20">
        <Box className="flex items-center">
          <PatientFileHeader patient={patient} isLoading={!isFetched} showBadges />
        </Box>
        <ArrowForwardIosIcon
          className="cursor-pointer"
          aria-label="close"
          onClick={handleDrawerClose}
        />
      </header>
      <Box className="w-full px-32 border-b-2 border-b-grey-20">
        <Tabs
          value={selectedTabTitle}
          onChange={changeSelectedTab}
          className="text-green-550 flex gap-x-8"
          aria-label="secondary tabs example"
        >
          {tabs.map(({ title }) => (
            <Tab key={title} value={title} label={title} className="capitalize" />
          ))}
        </Tabs>
      </Box>
      <Box className="grow overflow-y-auto relative">
        {selectedTabTitle === 'patient' && <PatientTab patient={patient} loading={!isFetched} />}
        {selectedTabTitle === 'order history' && (
          <OrderHistoryTab patientId={patient._id} handleDrawerClose={handleDrawerClose} />
        )}
        {selectedTabTitle === 'medicines' && <MedicinesTab patientId={patient._id} />}
      </Box>
    </ContainedSideDrawer>
  );
}

export default PatientDrawer;
